import { render, staticRenderFns } from "./CreateWorkflowTypeDialog.vue?vue&type=template&id=176fd460"
import script from "./CreateWorkflowTypeDialog.vue?vue&type=script&lang=js"
export * from "./CreateWorkflowTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports